import React from 'react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { ListRow, Button, SkeletonLoader } from '@frontend/design-system';

type SmartDraftCardProps = {
  smartDraft: string;
  show: boolean;
  isLoading: boolean;
  onMouseOver: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
  onClose: (e: React.MouseEvent) => void;
};

const SmartDraftCardLoader = () => {
  return (
    <div
      css={{
        maxWidth: 190,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.25),
      }}
    >
      <SkeletonLoader height={10} width={160} />
      <SkeletonLoader height={10} width={190} />
      <SkeletonLoader height={10} width={180} />
    </div>
  );
};

export const SmartDraftCard: React.FC<SmartDraftCardProps> = ({
  smartDraft,
  show,
  isLoading,
  onMouseOver,
  onMouseLeave,
  onClick,
  onClose,
}) => {
  if (!show && !isLoading) return null;
  if (!smartDraft && !isLoading) return null;

  return (
    <div
      css={{
        marginTop: theme.spacing(1),
        width: 'auto',
        maxWidth: 300,
      }}
    >
      <ListRow
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
        css={{
          cursor: 'pointer',
          fontSize: 'initial',
          alignItems: 'center',
          textAlign: 'left',
          padding: theme.spacing(1, 2),
          background: theme.colors.white,
          border: `solid 1px ${theme.colors.neutral10}`,
          borderRadius: theme.borderRadius.medium,
          transition: 'all 250ms ease',
          '&:hover, &:focus': {
            background: theme.colors.neutral5,
          },
        }}
        trackingId='inbox-thread-smart-draft-card'
      >
        <ListRow.Lead css={{ width: 24, padding: 0 }}>
          <Icon
            name='aiassistant-small'
            css={{
              color: theme.colors.neutral50,
            }}
          />
        </ListRow.Lead>
        <ListRow.Content>
          {isLoading ? (
            <SmartDraftCardLoader />
          ) : (
            <ListRow.Content.Subtitle
              css={{
                display: 'inline-block',
                width: 'auto',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                maxWidth: '100%',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {smartDraft}
            </ListRow.Content.Subtitle>
          )}
        </ListRow.Content>
        <ListRow.Trail>
          <Button
            variant='secondary'
            iconName='x'
            onClick={onClose}
            disabled={isLoading}
            trackingId='inbox-thread-smart-draft-close-btn'
          />
        </ListRow.Trail>
      </ListRow>
    </div>
  );
};
